import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, bindActionCreators, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import app from './reducers';
import { historyMiddleware } from './Middlewares/History.middleware';
import { add as addToCart, reorder } from './Actions/Cart.action';
import MiniCartContainer from './Containers/MiniCart.container';
import QuickSearchContainer from './Containers/QuickSearch.container';
import NavigationContainer from './Containers/Navigation.container';
import FacetedSearchContainer from './Containers/FacetedSearch.container';
import FacetedSearchCompactContainer from './Containers/FacetedSearchCompact.container';
import DynamicComponent from './Components/DynamicComponent';
import ShowVatContainer from "./Containers/ShowVat.container";
import AddressListContainer from "./Containers/AddressList.container";
import CartBulkinsertContainer from "./Containers/CartBulkinsert.container";
import ExportPricecontainer from "./Containers/ExportPrice.container";
import { trackingViewItem } from "./Services/tracking";
import NotificationContainer from './Containers/Notification.container';
import * as nshiftActions from './Actions/NShift.action';

window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
// use the parent page's store if possible, so the iframe will share the same store with the parent context.
// this to makes for example the Reorder button in My Page page to update the state and reload the mini cart
// when reorder action happens.
const store = window.__litium.store = window.__litium.store || (window.parent.__litium && window.parent.__litium.store)
    || createStore(app, preloadState, composeWithDevTools(applyMiddleware(thunk, historyMiddleware)));
// Expose nshift actions for manual console debugging
window.nshiftActions = nshiftActions;
window.__litium = {
    ...window.__litium,
    tracking: {
        trackingViewItem,
    },

    bootstrapComponents: () => {
        // bootstrap React components, in case the HTML response we receive from the server
        // has React components. ReactDOM.render performs only an update on previous rendered
        // components and only mutate the DOM as necessary to reflect latest React element.
        bootstrapComponents();
    },
    cache: {}, // for storing cache data for current request
};

const registeredContainers = [];
const renderReact = (element, container, callback) => {
    registeredContainers.push(container);
    ReactDOM.render(element, container, callback);
}

window.onunload = () => {
    // make sure components are unmounted, redux's listener are unsubscribed
    // to fix issue with iframe navigation in IE
    registeredContainers.forEach(container => {
        ReactDOM.unmountComponentAtNode(container);
    });
}

const bootstrapComponents = () => {
    if (document.getElementById('miniCart')) {
        renderReact(
            <Provider store={store}>
                <MiniCartContainer />
            </Provider>,
            document.getElementById('miniCart')
        );
    }
    if (document.getElementById('quickSearch')) {
        renderReact(
            <Provider store={store}>
                <QuickSearchContainer />
            </Provider>,
            document.getElementById('quickSearch')
        );
    }
    if (document.getElementById('navbar')) {
        renderReact(
            <Provider store={store}>
                <NavigationContainer />
            </Provider>,
            document.getElementById('navbar')
        );
    }
    if (document.getElementById('facetedSearch')) {
        renderReact(
            <Provider store={store}>
                <FacetedSearchContainer />
            </Provider>,
            document.getElementById('facetedSearch')
        );
    }
    if (document.getElementById('facetedSearchCompact')) {
        renderReact(
            <Provider store={store}>
                <FacetedSearchCompactContainer />
            </Provider>,
            document.getElementById('facetedSearchCompact')
        );
    }
    if (document.getElementById('globalNotification')) {
        ReactDOM.render(
            <Provider store={store}>
                <NotificationContainer />
            </Provider>,
            document.getElementById('globalNotification')
        );
    }
    if (document.getElementById('myPagePersons')) {
        const PersonList = DynamicComponent({
            loader: () => import('./Containers/PersonList.container')
        });
        renderReact(
            <Provider store={store}>
                <PersonList />
            </Provider>,
            document.getElementById('myPagePersons')
        );
    }
    if (document.getElementById('myPageAddresses')) {

        const AddressList = DynamicComponent({
            loader: () => import('./Containers/AddressList.container')
        });
        renderReact(
            <Provider store={store}>
                <AddressListContainer />
            </Provider>,
            document.getElementById('myPageAddresses')
        );
    }
    if (document.getElementById('cartBulkInsert')) {

        const CartBulkinsert = DynamicComponent({
            loader: () => import('./Containers/CartBulkinsert.container')
        });
        renderReact(
            <Provider store={store}>
                <CartBulkinsertContainer />
            </Provider>,
            document.getElementById('cartBulkInsert')
        );

    }


    if (document.getElementById('exportprice')) {
        renderReact(
            <Provider store={store}>
                <ExportPricecontainer />
            </Provider>,
            document.getElementById('exportprice')
        );
    }

    if (document.getElementById('checkout')) {
        const Checkout = DynamicComponent({
            loader: () => import('./Containers/Checkout.container')
        });
        renderReact(
            <Provider store={store}>
                <Checkout />
            </Provider>,
            document.getElementById('checkout')
        );
    }
    if (document.getElementById('lightBoxImages')) {
        const LightboxImages = DynamicComponent({
            loader: () => import('./Containers/LightboxImages.container')
        });
        const rootElement = document.getElementById('lightBoxImages');
        const images = Array.from(rootElement.querySelectorAll('a')).map(img => ({
            src: img.dataset.src,
            iframe: img.dataset.iframe == "true"
        }));
        const thumbnails = Array.from(rootElement.querySelectorAll('a img')).map(img => ({ src: img.src }));
        renderReact(
            <Provider store={store}>
                <LightboxImages images={images} thumbnails={thumbnails} />
            </Provider>,
            document.getElementById('lightBoxImages')
        );
    }

    if (document.querySelectorAll('.slider').length > 0) {
        const Slider = DynamicComponent({
            loader: () => import('./Components/Slider')
        });
        Array.from(document.querySelectorAll('.slider')).forEach((slider, index) => {
            const values = [...slider.querySelectorAll('.slider__block')].map(block => {
                return ({
                    sliderdata: JSON.parse(block.dataset.sliderdata),
                    isfullwidth: block.dataset.isfullwidth,
                    isshowdots: block.dataset.isshowdots,
                    delay: block.dataset.delay
                })
            });
            if (values.length > 0) {
                renderReact(
                    <Slider values={values} />,
                    slider
                );
            }
        });
    }

    if (document.getElementById("showVat")) {
        renderReact(
            <Provider store={store}>
                <ShowVatContainer />
            </Provider>,
            document.getElementById("showVat")
        );
    }
    if (document.querySelectorAll('buy-button').length > 0) {
        const BuyButton = DynamicComponent({
            loader: () => import('./Containers/BuyButton.container')
        });
        Array.from(document.querySelectorAll('buy-button')).forEach((button) => {
            const { articleNumber, quantityFieldId, href, cssClass, label, showLabel } = button.dataset;
            const showLabelBool = button.dataset.showLabel === "true"; // Convert to a boolean
            renderReact(
                <Provider store={store}>
                    <BuyButton {...{ label, articleNumber, quantityFieldId, href, cssClass, showLabel }} />
                </Provider>,
                button
            );
        });
    }

    if (document.querySelectorAll('reorder-button').length > 0) {
        const ReorderButton = DynamicComponent({
            loader: () => import('./Containers/ReorderButton.container')
        });
        Array.from(document.querySelectorAll('reorder-button')).forEach((button) => {
            const { cssClass, orderId, title } = button.dataset;
            const label = button.innerText;
            renderReact(
                <Provider store={store}>
                    <ReorderButton {...{ label, title, cssClass, orderId }} />
                </Provider>,
                button
            );
        });
    }
};

if (document.querySelectorAll('.productslider').length > 0) {
    const ProductSlider = DynamicComponent({
        loader: () => import('./Containers/ProductSlider.container'),
    });
    Array.from(document.querySelectorAll('.productslider')).forEach(
        (slider, index) => {
            const products = [
                ...slider.querySelectorAll('.product__block'),
            ].map((block) => {
                return {
                    product: block.dataset.product,
                    image: block.dataset.image,
                    tagImage: block.dataset.tagimage,
                };
            });
            if (products.length > 0) {
                ReactDOM.render(<ProductSlider products={products} productCount={slider.dataset.productcount} store={store} />, slider);
            }
        }
    );
}


if (document.querySelectorAll('.productsliderupsell').length > 0) {
    const ProductSlider = DynamicComponent({
        loader: () => import('./Containers/ProductSlider.container'),
    });

    // Function to initialize sliders in a given container or the whole document
    const initializeProductSliders = (container = document) => {
        Array.from(container.querySelectorAll('.productsliderupsell')).forEach((slider, index) => {
            const products = [
                ...slider.querySelectorAll('.product__block'),
            ].map((block) => ({
                product: block.dataset.product,
                image: block.dataset.image,
                tagImage: block.dataset.tagimage,
            }));

            if (products.length > 0) {
                ReactDOM.render(
                    <ProductSlider
                        products={products}
                        productCount={slider.dataset.productcount}
                        store={store}
                    />,
                    slider
                );
            }
        });
    };

    // Initialize all existing sliders on the page (old blocks)
    //initializeProductSliders();

    // Handle dynamic sliders in the upsell container
    const upsellContainer = document.getElementById('upsell-products');
    if (upsellContainer) {
        const observer = new MutationObserver(() => {
            if (upsellContainer.classList.contains('visible')) {
                initializeProductSliders(upsellContainer); // Initialize only the upsell sliders
            }
        });

        observer.observe(upsellContainer, { attributes: true, childList: true, subtree: true });

    }
}


if (document.querySelectorAll('.productslider__banner').length > 0) {
    const ProductBannerSlider = DynamicComponent({
        loader: () => import('./Containers/ProductBannerSlider.container'),
    });
    Array.from(document.querySelectorAll('.productslider__banner')).forEach(
        (slider, index) => {
            const products = [
                ...slider.querySelectorAll('.product__block'),
            ].map((block) => {
                return {
                    product: block.dataset.product,
                    image: block.dataset.image,
                    tagImage: block.dataset.tagimage,
                };
            });
            if (products.length > 0) {
                ReactDOM.render(<ProductBannerSlider products={products} productCount={slider.dataset.productcount} store={store} />, slider);
            }
        }
    );
}

if (document.getElementById('shoppingCart')) {
    const ShoppingCart = DynamicComponent({
        loader: () => import('./components/ShoppingCart'),
    });
    const rootElement = document.getElementById('shoppingCart');
    const { order } = rootElement.dataset;

    renderReact(
        <Provider store={store}>
            <ShoppingCart order={JSON.parse(order)} />
        </Provider>,
        document.getElementById('shoppingCart')
    );
}

bootstrapComponents();